import {PureComponent} from 'react';

import Item from './Item';

class Wrapper extends PureComponent {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    render() {
        return <Item {...this.props} onClick={this.handleClick} />;
    }

    handleClick(event) {
        const {onSelect, ...props} = this.props;

        event.preventDefault();
        event.stopPropagation();

        return onSelect && onSelect(props);
    }

}

export default Wrapper;
